import {pxToRem} from '../../../utills/pxToRem'

export const paymentSectionStyles = {
    '.chakra-checkbox__label': {
        color: 'cav_light_input_gray'
    },
    'chakra-checkbox__label[data-checked]': {
        color: 'cav_pdp_dark_gray'
    }
}

export const promoButtonStyle = {
    width: '100%',
    display: 'inline',
    '.button-primary': {
        minWidth: pxToRem(90)
    }
}

export const anotherPaypalAccountLabel = {
    fontSize: pxToRem(14),
    fontWeight: 700,
    marginBottom: 0
}
